export default function About() {
  return (
    <section className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">What APEX Does</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            APEX is a selective book promotion service that connects exceptional authors with highly engaged book club communities. We don't promote every book—we carefully evaluate and choose only standout titles for our limited campaign slots.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/71fb85254033bafb869bece88251a14d.jpg"
              alt="Engaged book club discussion"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>
          
          <div className="space-y-8">
            <div className="flex gap-6">
              <div className="flex-shrink-0 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Careful Evaluation</h3>
                <p className="text-gray-700 leading-relaxed">
                  We evaluate books based on Amazon and Goodreads descriptions, use platforms like Readnrate to understand reader interests, and select only the most compelling titles.
                </p>
              </div>
            </div>
            
            <div className="flex gap-6">
              <div className="flex-shrink-0 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-group-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Perfect Matching</h3>
                <p className="text-gray-700 leading-relaxed">
                  With years of experience, we know exactly how to position your book so readers become genuinely interested and eager to discuss it with their communities.
                </p>
              </div>
            </div>
            
            <div className="flex gap-6">
              <div className="flex-shrink-0 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Clear Communication</h3>
                <p className="text-gray-700 leading-relaxed">
                  We communicate with authors primarily through email for clarity and efficiency, ensuring every detail of your campaign is handled professionally.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
